import { useMemo } from 'react';

import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';

// project imports
// import Search from './Search';
// import Message from './Message';
import Profile from './Profile';
import Notification from './Notification';
// import FullScreen from './FullScreen';
import MobileSection from './MobileSection';
// import MegaMenuSection from './MegaMenuSection';
import FontSizeButtons from './FontSizeButtons';

import useConfig from 'hooks/useConfig';
import { MenuOrientation } from 'config';
import DrawerHeader from 'layout/Dashboard/Drawer/DrawerHeader';

// ==============================|| HEADER - CONTENT ||============================== //

export default function HeaderContent() {
  const { menuOrientation } = useConfig();
  const downLG = useMediaQuery((theme) => theme.breakpoints.down('lg'));

  // const megaMenu = useMemo(() => <MegaMenuSection />, []);

  return (
    <>
      {menuOrientation === MenuOrientation.HORIZONTAL && !downLG && <DrawerHeader open={true} />}
      {/* {!downLG && <Search />} */}
      {/* {!downLG && megaMenu} */}
      {downLG && <Box sx={{ width: '100%', ml: 1 }} />}

      <Box sx={{ display: 'flex', alignItems: 'center', ml: 'auto' }}>
        <FontSizeButtons />
        <Notification />
        {/* <Message /> */}
        {/* {!downLG && <FullScreen />} */}
        {!downLG && <Profile />}
        {downLG && <MobileSection />}
      </Box>
    </>
  );
}
